import React from 'react'

class Footer extends React.Component {
    render() {
        return (
            <div id="footer">
                <div className="inner">
                    <ul className="icons">
                        <li><a target="_blank" rel="noopener noreferrer" title="GitHub Profile" href="https://github.com/yvesh" className="icon fa-github"><span className="label">Github</span></a></li>
                        <li><a target="_blank" rel="noopener noreferrer" title="Twitter" href="https://twitter.com/yveshoppe" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
                        <li><a target="_blank" rel="noopener noreferrer" title="FaceBook" href="https://www.facebook.com/yves.hoppe" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
                        <li><a target="_blank" rel="noopener noreferrer" title="LinkedIn" href="https://www.linkedin.com/in/yveshoppe/" className="icon fa-linkedin"><span className="label">LinkedIn</span></a></li>
                    </ul>
                    <ul className="copyright">
                        <li>&copy; 2002 - {new Date().getFullYear()} Yves Hoppe</li>
                        <li>No Tracking</li>
                        <li>No Cookies</li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default Footer;
